import { useState } from "react";
import styled from "styled-components";

import {
  Panel,
  SafePanel,
  ColumnContainer,
  RowContainer,
  ScrollContainerSize,
  Space,
  LabelXXL,
  LabelL,
  Label,
  Input,
  Button,
  RoundedContainer,
  Divider,
} from "../components/Ui/Ui";

const NumberInput = styled(Input).attrs({
  onWheel: (e) => e.target.blur(),
})`
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
const Calculator = () => {
  const [parts, setParts] = useState([
    {
      id: 1,
      name: "",
      price: "",
      discount: "",
    },
  ]);

  const [customerDiscount, setCustomerDiscount] = useState(50);

  const [workHours, setWorkHours] = useState("");
  const [hourlyRate, setHourlyRate] = useState("");

  const [disposal, setDisposal] = useState("");
  const [other, setOther] = useState("");

  const addPart = () => {
    setParts([
      ...parts,
      {
        id: Date.now(),
        name: "",
        price: "",
        discount: "",
      },
    ]);
  };

  const removePart = (id) => {
    if (parts.length === 1) return;
    setParts(parts.filter((part) => part.id !== id));
  };

  const updatePart = (id, field, value) => {
    setParts(
      parts.map((part) =>
        part.id === id
          ? {
              ...part,
              [field]: value,
            }
          : part
      )
    );
  };


const calculatePartPrice = (part) => {
  const purchasePrice = parseFloat(part.price) || 0;
  const discount = parseFloat(part.discount) || 0;

  if (purchasePrice <= 0) return 0;
  if (discount <= 0) return purchasePrice;

  const matthiesPrice = purchasePrice / (1 - discount / 100);
  const priceDifference = matthiesPrice - purchasePrice;

  // 0 %  -> Kunde zahlt vollen Matthies-Verkaufspreis
  // 100% -> Kunde zahlt unseren Einkaufspreis
  return matthiesPrice - priceDifference * (customerDiscount / 100);
};

  const calculateMatthiesPrice = (part) => {
    const purchasePrice = parseFloat(part.price) || 0;
    const discount = parseFloat(part.discount) || 0;

    if (purchasePrice <= 0) return 0;
    if (discount <= 0) return purchasePrice;

    return purchasePrice / (1 - discount / 100);
  };

  const partsTotal = parts.reduce(
    (total, part) => total + calculatePartPrice(part),
    0
  );

  const workTotal =
    (parseFloat(workHours) || 0) * (parseFloat(hourlyRate) || 0);

  const disposalTotal = parseFloat(disposal) || 0;
  const otherTotal = parseFloat(other) || 0;

  const netTotal = partsTotal + workTotal + disposalTotal + otherTotal;

  const tax = netTotal * 0.19;
  const grossTotal = netTotal + tax;

  const euro = (value) =>
    value.toLocaleString("de-DE", {
      style: "currency",
      currency: "EUR",
    });

  return (
    <Panel>
      <SafePanel normal={false} allowMargin={false}>
        <ColumnContainer style={{ width: "100%" }}>
          <RowContainer style={{ alignItems: "center" }}>
            <LabelXXL color="White" fontWeight="900">
              Rechner
            </LabelXXL>
          </RowContainer>

          <ScrollContainerSize
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            {/* KUNDENRABATT */}
            <RoundedContainer pressable={false}>
              <ColumnContainer>
                <LabelL fontWeight="900">Kundenrabatt</LabelL>

                <Space style={{ height: "0.5rem" }} />

                <Label>Wie viel vom Matthies-Rabatt bekommt der Kunde?</Label>

                <Space style={{ height: "0.4rem" }} />

                <RowContainer style={{ alignItems: "center", gap: "1rem" }}>
                  <Input
                    type="range"
                    min="0"
                    max="100"
                    step="10"
                    value={customerDiscount}
                    onChange={(e) =>
                      setCustomerDiscount(Number(e.target.value))
                    }
                    style={{ flex: 1, marginBottom: 0 }}
                  />

                  <LabelL fontWeight="900">{customerDiscount} %</LabelL>
                </RowContainer>

                <Space style={{ height: "0.3rem" }} />

                <Label>
                  0 % = voller Matthies-Verkaufspreis&nbsp;&nbsp; | &nbsp;&nbsp; 50 % = halber
                  Rabatt&nbsp;&nbsp; | &nbsp;&nbsp; 100 % = Einkaufspreis
                </Label>
              </ColumnContainer>
            </RoundedContainer>

            {/* TEILE */}
            <RoundedContainer pressable={false}>
              <ColumnContainer>
                <LabelL fontWeight="900">Autoteile</LabelL>

                <Space style={{ height: "0.75rem" }} />

                {parts.map((part, index) => (
                  <div key={part.id}>
                    <RowContainer
                      style={{
                        alignItems: "flex-end",
                        gap: "0.75rem",
                        width: "100%",
                      }}
                    >
                      <div style={{ flex: 2, minWidth: 0 }}>
                        <Label>Teil</Label>
                        <Input
                          type="text"
                          placeholder="z. B. Ölfilter"
                          value={part.name}
                          onChange={(e) =>
                            updatePart(part.id, "name", e.target.value)
                          }
                        />
                      </div>

                      <div style={{ flex: 1, minWidth: 0 }}>
                        <Label>Unser Preis €</Label>
                        <NumberInput
                          type="number"
                          min="0"
                          step="0.01"
                          placeholder="z. B. 7,00"
                          value={part.price}
                          onChange={(e) =>
                            updatePart(part.id, "price", e.target.value)
                          }
                        />
                      </div>

                      <div style={{ flex: 1, minWidth: 0 }}>
                        <Label>Matthies Rabatt %</Label>
                        <NumberInput
                          type="number"
                          min="0"
                          max="100"
                          step="1"
                          placeholder="z. B. 15"
                          value={part.discount}
                          onChange={(e) =>
                            updatePart(part.id, "discount", e.target.value)
                          }
                        />
                      </div>

                      <div style={{ flex: 1, minWidth: 0 }}>
                        <Label>Matthies Verkaufspreis</Label>
                        <Input
                          type="text"
                          value={euro(calculateMatthiesPrice(part))}
                          readOnly
                        />
                      </div>

                      <div style={{ flex: 1, minWidth: 0 }}>
                        <Label>Kundenpreis</Label>
                        <Input
                          type="text"
                          value={euro(calculatePartPrice(part))}
                          readOnly
                        />
                      </div>

                      <Button
                        bgColor="#b00020"
                        hoverColor="#800018"
                        onClick={() => removePart(part.id)}
                        disabled={parts.length === 1}
                        style={{ marginBottom: "1rem", flexShrink: 0 }}
                      >
                        X
                      </Button>
                    </RowContainer>

                    {index < parts.length - 1 && (
                      <Divider style={{ margin: "0.5rem 0" }} />
                    )}
                  </div>
                ))}

                <Space style={{ height: "0.5rem" }} />

                <Button bgColor="#222" hoverColor="#444" onClick={addPart}>
                  + Teil hinzufügen
                </Button>

                <Space style={{ height: "0.5rem" }} />

                <LabelL fontWeight="900">
                  Teile gesamt: {euro(partsTotal)}
                </LabelL>
              </ColumnContainer>
            </RoundedContainer>

            {/* ARBEIT */}
            <RoundedContainer pressable={false}>
              <ColumnContainer>
                <LabelL fontWeight="900">Arbeitszeit</LabelL>

                <Space style={{ height: "0.75rem" }} />

                <RowContainer style={{ gap: "0.75rem", width: "100%" }}>
                  <div style={{ flex: 1 }}>
                    <Label>Stunden</Label>
                    <NumberInput
                      type="number"
                      min="0"
                      step="0.1"
                      placeholder="z. B. 1,5"
                      value={workHours}
                      onChange={(e) => setWorkHours(e.target.value)}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <Label>Stundenlohn / Verrechnungssatz €</Label>
                    <NumberInput
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="z. B. 90"
                      value={hourlyRate}
                      onChange={(e) => setHourlyRate(e.target.value)}
                    />
                  </div>
                </RowContainer>

                <Space style={{ height: "0.5rem" }} />

                <LabelL fontWeight="900">
                  Arbeit gesamt: {euro(workTotal)}
                </LabelL>
              </ColumnContainer>
            </RoundedContainer>

            {/* SONSTIGES */}
            <RoundedContainer pressable={false}>
              <ColumnContainer>
                <LabelL fontWeight="900">Sonstiges</LabelL>

                <Space style={{ height: "0.75rem" }} />

                <RowContainer style={{ gap: "0.75rem", width: "100%" }}>
                  <div style={{ flex: 1 }}>
                    <Label>Entsorgung €</Label>
                    <NumberInput
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="0,00"
                      value={disposal}
                      onChange={(e) => setDisposal(e.target.value)}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <Label>Sonstiges €</Label>
                    <NumberInput
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="0,00"
                      value={other}
                      onChange={(e) => setOther(e.target.value)}
                    />
                  </div>
                </RowContainer>
              </ColumnContainer>
            </RoundedContainer>

            {/* ERGEBNIS */}
            <RoundedContainer pressable={false}>
              <ColumnContainer>
                <LabelL fontWeight="900">Ergebnis</LabelL>

                <Space style={{ height: "0.5rem" }} />

                <RowContainer
                  style={{
                    justifyContent: "space-between",
                    gap: "1rem",
                    width: "100%",
                  }}
                >
                  <Label>Teile: {euro(partsTotal)}</Label>
                  <Label>Arbeit: {euro(workTotal)}</Label>
                  <Label>Entsorgung: {euro(disposalTotal)}</Label>
                  <Label>Sonstiges: {euro(otherTotal)}</Label>
                </RowContainer>

                <Divider style={{ margin: "0.75rem 0" }} />

                <RowContainer
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <ColumnContainer>
                    <LabelL fontWeight="900">Netto: {euro(netTotal)}</LabelL>
                    <LabelL fontWeight="900">MwSt. 19 %: {euro(tax)}</LabelL>
                  </ColumnContainer>

                  <LabelXXL fontWeight="900">{euro(grossTotal)}</LabelXXL>
                </RowContainer>
              </ColumnContainer>
            </RoundedContainer>
          </ScrollContainerSize>
        </ColumnContainer>
      </SafePanel>
    </Panel>
  );
};

export default Calculator;